
























































import {Component, Vue} from "vue-property-decorator";
import HelpMenuItem from "@/components/for-help-page/HelpMenuItem.vue";
import Page from "@/components/for-page-grid/Page.vue";

@Component({
  components: {Page, HelpMenuItem},
  computed: {
    html() {
      return this.$route.meta.html || "";
    },
  },
})
class Help extends Vue {
  isMini = false;
  menuList: any[] = [];

  formatList(list, level = -1): any[] {
    let result: any[] = [];
    list.forEach(item => {
      const {title, routeName, children} = item;
      result.push({title, routeName, level: level + 1});
      result = result.concat(this.formatList(children, level + 1));
    });
    return result;
  }

  mounted() {
    try {
      this.menuList = this.formatList(
        JSON.parse(process.env && process.env.VUE_APP_HELP_MENU || '[]')
      );
    } catch (e) {
      console.log(e);
    }
  }
}
export default Help;

